import React from 'react';

export const AutoScrollContext = React.createContext({
    isNavClick: false,
    setIsNavClick: () => {},
});
